<template>
  <div>
    <div class="signature-box">
      <canvas v-if="idCopy == '' && previewId == ''" :ref="field" class="div_canvas_container1" id="signCanvas" :style="{'background-color':'#fff'}"
        @touchstart="touchStart" @touchmove="touchMove" @touchend="touchEnd"
        @mousedown="mouseDown" @mousemove="mouseMove" @mouseup="mouseUp">
      </canvas>
			<div v-else-if="idCopy != ''" class="div_canvas_container1">
				<img :src="previewId" alt="" >
			</div>
			<div v-else-if="previewId != ''" class="div_canvas_container2">
				<img :src="previewId" alt="" style='max-width:100%;max-height:100%;'>
			</div>
			<div class="bts flex" v-if="!disabled && idCopy != ''">
				<el-button @click.native="clearwrite" size="small" class="gray resetBtn" round type="primary">重置</el-button>
				<el-button @click.native="commit" :disabled="previewId == ''" size="small" class="gray resetBtn" round type="primary">保存</el-button>
				<el-button @click.native="pasteSign" :disabled="personalSignFile == null" size="small" class="gray resetBtn" round type="primary">使用笔迹</el-button>
			</div>
      <div class="bts flex" v-if="!disabled && idCopy == ''">
        <el-button @click.native="overwrite" size="small" class="gray resetBtn" round type="primary">重置</el-button>
        <el-button @click.native="commit" size="small" round>保存</el-button>
				<!-- <el-button @click.native="copySign"  size="small" class="gray resetBtn" round type="primary">保存笔迹</el-button> -->
				<el-button @click.native="pasteSign" :disabled="personalSignFile == null" size="small" class="gray resetBtn" round type="primary">使用笔迹</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import PubSub from 'pubsub-js'
export default {
    //数字签名
    name : 'signCanvas',
    props:{
      width:{
        type:[Number,String],
        default:300,
      },
      height:{
        type:[Number,String],
        default:150,
      },
      filename:{
        type:String,
			},
			fillStyle:{
				type:String,
				value: '#fff'
			},
			strokeStyle:{
				type:String,
				value: '#000'
			},
			disabled:{
				type: Boolean,
			},
			id:{
				type: [String,Array],
				default:'',
			},
			field:{
				type: String,
				default:'',
			},
			tableField:{
				type: String,
				default:'',
			},
			companySign:{
				type: Boolean,
			},
			previewId:{
				type: String,
				default:'',
			},
    },
    data() {
      return{
		  		baseqzid:'',
				signKey:0,

				d_signed: false, // 签过名
				stageInfo: {},
				points: [],
				canvasTxt: null,
				startX: 0,
				startY: 0,
				moveY: 0,
				moveX: 0,
				w: null,
				h: null,
				isDown: false,
				signCanvas:undefined,
				idCopy:'',
				personalSignFile:sessionStorage.getItem('personalSignFile')
      }
    },
    mounted() {
			var _that = this
			this.getSignFile()
    },
    methods: {

			/**** mobile start ****/
			touchStart(ev) {
				let canvas = this.$refs[this.field]
				this.canvasTxt = canvas.getContext('2d')
				this.stageInfo = canvas.getBoundingClientRect()

				ev = ev || event
				ev.preventDefault()
				if (ev.touches.length == 1) {
					let obj = {
						x: ev.targetTouches[0].clienX,
						y: ev.targetTouches[0].clientY
					}
					this.startX = obj.x
					this.startY = obj.y
					this.canvasTxt.beginPath()
					this.canvasTxt.moveTo(this.startX, this.startY)
					this.canvasTxt.lineTo(obj.x, obj.y)
					this.canvasTxt.lineWidth = 4 //线条宽度
					this.canvasTxt.stroke()
					this.canvasTxt.closePath()
					this.points.push(obj)
				}
			},
			touchMove(ev) {
				ev = ev || event
				ev.preventDefault()
				if (ev.touches.length == 1) {
					let obj = {
						x: ev.targetTouches[0].clientX - this.stageInfo.left,
						y: ev.targetTouches[0].clientY - this.stageInfo.top
					}
					this.moveY = obj.y
					this.moveX = obj.x-((obj.x-100)/10)
					this.canvasTxt.beginPath()
					this.canvasTxt.moveTo(this.startX, this.startY)
					this.canvasTxt.lineTo(obj.x-((obj.x-100)/10), obj.y)
					this.canvasTxt.lineWidth = 4 //线条宽度
					this.canvasTxt.stroke()
					this.canvasTxt.closePath()
					this.startY = obj.y
					this.startX = obj.x-((obj.x-100)/10)
					this.points.push(obj)
				}
			},
			touchEnd(ev) {
				ev = ev || event
				ev.preventDefault()
				if (ev.touches.length == 1) {
					let obj = {
						x: ev.targetTouches[0].clientX - this.stageInfo.left,
						y: ev.targetTouches[0].clientY - this.stageInfo.top
					}
					this.canvasTxt.beginPath()
					this.canvasTxt.moveTo(this.startX, this.startY)
					this.canvasTxt.lineTo(obj.x, obj.y)
					this.canvasTxt.lineWidth = 4 //线条宽度
					this.canvasTxt.stroke()
					this.canvasTxt.closePath()
					this.points.push(obj)
				}
				this.d_signed = true
			},
			/**** mobile end ****/
			/**** pc start ****/
			mouseDown(ev) {
				let canvas = this.$refs[this.field]
				this.canvasTxt = canvas.getContext('2d')
				this.stageInfo = canvas.getBoundingClientRect()
				ev = ev || event
				ev.preventDefault()
				let obj = {
					x: ev.offsetX,
					y: ev.offsetY
				}
				this.startX = obj.x
				this.startY = obj.y
				this.canvasTxt.beginPath()
				this.canvasTxt.moveTo(this.startX, this.startY)
				this.canvasTxt.lineTo(obj.x, obj.y)
				this.canvasTxt.lineWidth = 4 //线条宽度
				this.canvasTxt.stroke()
				this.canvasTxt.closePath()
				this.points.push(obj)
				this.isDown = true
			},
			mouseMove(ev) {
				ev = ev || event
				ev.preventDefault()
				if (this.isDown && this.width-10 > ev.offsetX && this.height-10 > ev.offsetY && ev.offsetY-10 > 0 && ev.offsetX-10 > 0) {
					let obj = {
						x: ev.offsetX,
						y: ev.offsetY
					}
					this.moveY = obj.y
					this.moveX = obj.x
					this.canvasTxt.beginPath()
					this.canvasTxt.moveTo(this.startX, this.startY)
					this.canvasTxt.lineTo(obj.x, obj.y)
					this.canvasTxt.lineWidth = 4 //线条宽度
					this.canvasTxt.stroke()
					this.canvasTxt.closePath()
					this.startY = obj.y
					this.startX = obj.x
					this.points.push(obj)
				}else if(this.isDown){
					this.isDown = false
				}
			},
			mouseUp(ev) {
				ev = ev || event
				ev.preventDefault()
					let obj = {
						x: ev.offsetX,
						y: ev.offsetY
					}
					this.canvasTxt.beginPath()
					this.canvasTxt.moveTo(this.startX, this.startY)
					this.canvasTxt.lineTo(obj.x, obj.y)
					this.canvasTxt.lineWidth = 4 //线条宽度
					this.canvasTxt.stroke()
					this.canvasTxt.closePath()
					this.points.push(obj)
					this.points.push({
						x: -1,
						y: -1
					})
					this.isDown = false
					this.d_signed = true
			},
			/**** pc end ****/
			// 重写
			overwrite() {
				this.d_signed = false
				this.$nextTick(() => {
					this.canvasTxt?.clearRect && this.canvasTxt?.clearRect(0, 0, this.$refs[this.field]?.width, this.$refs[this.field]?.height)
					this.points = []
				})
				/* 如果不是多人签字 */
				if(!this.companySign){
					//需要删除数据库中内容
					this.$emit('clearwrite',this.idCopy)
				}
				this.previewId = ''
				this.idCopy = ''
				this.signKey++;
			},
			/* 重置需要删除当前签字id */
			clearwrite(){
				/* 删除重新渲染的签字 */
				let _that = this
				/* 如果不是多人签字 */
				if(!this.companySign){
					//需要删除数据库中内容
					this.$emit('clearwrite',this.idCopy)
				}
				this.previewId = ''
				this.idCopy = ''
				this.signKey++;
			},
		copySign(){
		//  this.commit();
				this.$axios.get(this.idCopy,{ responseType: "blob"})
				.then(res => {
					if(res.data instanceof Blob){
						const reader = new FileReader()
						reader.readAsDataURL(res.data)
						reader.onload = () =>{
							//base64
							let userId = sessionStorage.getItem('userId')
							this.$axios.post('/dform/inForm/getBaseQz', {userId})
							.then((res) => {
								if(res.data.data){
									return this.$axios.post('/dform/inForm/saveBaseQz',{ID:res.data.data.id,userId,base64Img:reader.result})
								}else{
									return this.$axios.post('/dform/inForm/saveBaseQz',{ID:'',userId,base64Img:reader.result})
								}
							},() => {
							}).then((res) =>{
								if(res.data.code){
									sessionStorage.setItem('personalSignFile',reader.result)
								}
							},() => {
							})
						}
					}
				})
			},
			pasteSign(){
				let userId = sessionStorage.getItem('userId')
				this.$axios.post('/dform/inForm/getBaseQz', {userId})
				.then((res) => {
					if(res.data.data){
						this.$nextTick(() => {
							this.previewId = res.data.data.QZBCB_QZBASE
							this.baseqzid = res.data.data.id;
						})
					}else{
					}
				},() => {
				})

			},
			getSignFile(){
				let userId = sessionStorage.getItem('userId')
				this.$axios.post('/dform/inForm/getBaseQz', {userId})
				.then((res) => {
					if(res.data.data){
						this.personalSignFile = res.data.data.QZBCB_QZBASE
					}
				})
			},
			// 提交签名
			commit() {
				let formdata = this.dataURLtoFile(this.$refs[this.field]?this.$refs[this.field]?.toDataURL():this.previewId )
				this.$emit('addSignFile', formdata) //将数据返回给组件v-model绑定的值
				this.$emit('addSignBase64', this.$refs[this.field]?this.$refs[this.field]?.toDataURL():this.previewId) //将数据返回给组件v-model绑定的值
				// this.copySign()
			},
			// 将base64转换成file对象
			dataURLtoFile(dataurl, filename = new Date().getTime()) {
				let arr = dataurl.split(',')
				let mime = arr[0].match(/:(.*?);/)[1]
				let suffix = mime.split('/')[1]
				let bstr = atob(arr[1])
				let n = bstr.length
				let u8arr = new Uint8Array(n)
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n)
				}
				var file = new File([u8arr], `${filename}.${suffix}`, {
					type: mime
				})
				var formdata = new FormData() // 创建form对象
				formdata.append('file', file) // 通过append向form对象添加数据,可以通过append继续添加数//或formdata1.append('img',file);
				let uuid = this.common.uuid().replace(/-/g, "");
				return formdata
			},
			getSignPic(val){
				this.$axios.get('/mongodb/getDownloadOutputStream?fileId='+val)
				.then(res => {
					if(res.data.code){
					}
				})
			}
		},
	watch:{
			id:{
				handler(val,oldVal){
					if(val){
						let _that = this
						if(!_that.companySign){
							// let idCopy = JSON.parse(JSON.stringify(val))
							// _that.idCopy=idCopy[0].url;
							this.idCopy = JSON.parse(JSON.stringify(val))
						}
						if(val.indexOf('[') != -1){
							val = JSON.parse(val)
						}
						/* 多人签字复现 */
						if(val instanceof Array && val.length){
							_that.previewId = val[0].url
						}else{
							// _that.previewId = sessionStorage.getItem('baseURL') + '/mongodb/getDownloadOutputStream?fileId=' + val
							// let idCopy = JSON.parse(JSON.stringify(_that.previewId))
							// _that.idCopy=idCopy;
							this.$axios.get(sessionStorage.getItem('baseURL') + '/mongodb/getFileAsBASE64?fileId=' + this.idCopy)
								.then(res => {
									if(res.data){
									if(res.data.data){
										_that.previewId = 'data:image/png;base64,' + res.data.data
									}
									}
								})
						}
						// _that.copySign()
							/* 判断没有签字的情况 */
						// this.$axios.get(sessionStorage.getItem('baseURL')+'/mongodb/getDownloadOutputStream?fileId='+val)
						// .then((res) => {
						// 	if(!res.data){
						// 		_that.idCopy = ''
						// 		_that.previewId = ''
						// 		if(!this.companySign) PubSub.publish('changeValue',{tableField: this.tableField, value: '',})
						// 	}
						// })
					}
				},
				deep:true,
				immediate:true,
			}
		}
}


</script>
<style>
  .div_canvas_container {
    width: 200px;
    height: 100px;
    overflow: hidden;
  }
	.div_canvas_container1, .div_canvas_container2{
    width: 100%;
    height: 150px;
    overflow: hidden;
  }
  #signCanvas{
    border: none;
    box-sizing: border-box;
    overflow: hidden;
	}
</style>
